/* Dansk katalog for locale-invoice-detail-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'inv.pay.originalAmount': 'Beløb i {currency}',
  'inv.pay.bankAmountCurrency': 'Bankbeløb i {currency}',
  'inv.pay.fxPreview': 'Tilgodehavendet lukkes med {receivable} {accountingCurrency}. Differencen mod bankbeløbet bogføres som {kind}: {difference}.',
  'inv.pay.fxGain': 'valutagevinst',
  'inv.pay.fxLoss': 'valutatab',
});
